// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--2UoXa"};